import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { useForm } from "react-hook-form";
import ls from 'local-storage';
import PhoneInput from 'react-phone-number-input/input';
import Loading from '../../../Component/Loading/Loading';
import LoginActions from '../../Login/LoginAction'
import API from "../../../Services/BaseService";
import StateAndCity from '../../../Component/StateAndCity/StateAndCity'
import CommonPopup from '../../../Component/CommonPopup/CommonPopup';
import ManageAccountLinks from "../../../Component/ManageAccountLinks/ManageAccountLinks";
import appstore from '../../../assets/img/appstore.png';
import googleplay from '../../../assets/img/googleplay.png';
import adduser from '../../../assets/img/adduser.jpg';
import LoginReducer from '../../Login/LoginReducer';
import PhoneInputs from 'react-phone-input-2'
import StateAndCitySearch from '../../../Component/StateAndCity/StateAndCitySearch';
import PageNotFound from '../../FallBackUI/PageNotFound';
import { Button } from 'antd';
import { Modal } from 'react-bootstrap';

const EditMyProfile = (props) => {
    const history = useHistory();
    const { id } = props.location.state;
    console.log("id", id)
    let { register, updateMyProfile, formState: { errors }, reset } = useForm();
    const dealerData = useSelector(state => state.DealerReducer.payload);
    console.log("dealerData=======", dealerData);
    // const { id } = useParams();
    const { user_id } = useParams();
    const { buyer_id } = useParams();
    const userDetails = ls.get('userDetails');
    const [myProfileObjc, setMyProfileObj] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [primaryPhone, setPrimaryPhone] = useState("");
    const [mobilePhone, setMobilePhone] = useState("");
    const [emailId, setEmailId] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [address, setAddress] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [zipcode, setZipcode] = useState("");
    const [stateCityFlag, setStateCityFlag] = useState("");
    // const [locationName, setLocationName] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [type, setType] = useState("");
    const [cellFlag, setCellFlag] = useState(false);
    const [alterPhoneFlag, setAlterPhoneFlag] = useState(false);
    const [popupTitle, setPopupTitle] = useState("");
    const [popupMsg, setPopupMsg] = useState("");
    const [popupType, setPopupType] = useState("");
    const [popupActionType, setPopupActionType] = useState("");
    const [popupActionValue, setPopupActionValue] = useState("");
    const [popupActionPath, setPopupActionPath] = useState("")
    const [addressError, setAddressError] = useState("")
    const [primaryPhoneError, setPrimaryPhoneError] = useState("")
    const [mobilePhoneError, setMobilePhoneError] = useState("")
    const [stateAndCityError, setStateAndCityError] = useState("")
    const [image, setImage] = useState("");
    const [doc, setDoc] = useState("");
    const sellerDetails = useSelector(state => state.LoginReducer.payload);
    console.log("edit profile sellerDetails=====", sellerDetails)
    const dispatch = useDispatch();
    const [email, setEmail] = useState("");
    const [phoneNo, setPhoneNo] = useState([{ "id": `phoneNo${0}`, "phone_no": "", "extentation": "", "country_code": "+1" }]);
    console.log("setPhoneNo", phoneNo);
    const [phoneFields, setPhoneFields] = useState([{ "id": `phoneNo${0}`, "phone_no": "", "extentation": "", "country_code": "+1" }]);
    console.log("setPhoneFields", phoneFields);
    const [fields, setFields] = useState([]);
    const [loading, setLoading] = useState(true);

    const [editErrors, setEditErrors] = useState("");
    const [errorFlag, setErrorFlag] = useState(false);

    const backUrl = ls.get("backredirection");
    console.log("check the back direction", backUrl.slice(0, -1));
    const back = backUrl[(backUrl.length) - 1];
    console.log("checking the ls.set", backUrl[(backUrl.length) - 1]);

    const billofsale = ls.get("BillofSaleId")
    console.log("check the bill of sale value", billofsale);
    const CarId = ls.get("BillOfSaleCarId")
    const [confirmationFlag, setConfirmationFlag] = useState(false);
    const [changesArray, setChangesArray] = useState([]);
    const [changesFlag, setChangesFlag] = useState("no");
    const [extentation, setExtentation] = useState("");
    const [otherEmail, setOtherEmail] = useState([]);
    const [originalValues1, setOriginalValues1] = useState({});
    const [originalValues2, setOriginalValues2] = useState({});
    const [country, setCountry] = useState("");

    const [optionPhone, setOptionPhone] = useState("+1");

    const confirmationPopup = () => {

        setConfirmationFlag(!confirmationFlag)

    }

    const togglePopup = () => {
        setIsOpen(!isOpen);
    }

    const handleAddressChange = (e) => {
        setChangesFlag("yes")
        const newValue = e.target.value;
        const oldvalue = myProfileObjc.address;
        setAddress(newValue);
        const existingChangeIndex = changesArray.findIndex(change => change.name === 'address');
        if (existingChangeIndex !== -1) {
            const updatedChangesArray = [...changesArray];
            updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: 'address' };
            setChangesArray(updatedChangesArray);
        } else {
            const change = { oldvalue, newvalue: newValue, name: 'address' };
            setChangesArray([...changesArray, change]);
        }
    }
    console.log("changesArray", changesArray)


    const getStateName = (stateData, flag, type) => {
        console.log("getStateName", stateData)
        setChangesFlag("yes")
        setState(stateData)
        setStateCityFlag(flag)
        console.log("getStateName", flag)
        const oldvalue = myProfileObjc.state_name;

        setChangesArray((prevChangesArray) => {
            const existingChangeIndex = prevChangesArray.findIndex((change) => change.name === type);

            if (existingChangeIndex !== -1) {
                const updatedChangesArray = [...prevChangesArray];
                updatedChangesArray[existingChangeIndex] = { oldvalue: oldvalue, newvalue: stateData, name: type };
                return updatedChangesArray;
            } else {
                const change = { oldvalue: oldvalue, newvalue: stateData, name: type };
                return [...prevChangesArray, change];
            }
        });
    }

    const getCityName = (cityData, flag, type) => {
        setCity(cityData)
        setChangesFlag("yes")
        const oldvalue = myProfileObjc.city_name;

        setChangesArray((prevChangesArray) => {
            const existingChangeIndex = prevChangesArray.findIndex((change) => change.name === type);

            if (existingChangeIndex !== -1) {
                const updatedChangesArray = [...prevChangesArray];
                updatedChangesArray[existingChangeIndex] = {
                    ...updatedChangesArray[existingChangeIndex],
                    newvalue: cityData,
                };
                return updatedChangesArray;
            } else {
                const change = { oldvalue: oldvalue, newvalue: cityData, name: type };
                return [...prevChangesArray, change];
            }
        });
    }

    const getZipCodeId = (zipData, flag, type) => {
        setZipcode(zipData)
        setChangesFlag("yes")
        const oldvalue = myProfileObjc.zipcode;

        setChangesArray((prevChangesArray) => {
            const existingChangeIndex = prevChangesArray.findIndex((change) => change.name === type);
            const updatedFlag = flag || 'dropdown';
            if (existingChangeIndex !== -1) {
                const updatedChangesArray = [...prevChangesArray];
                updatedChangesArray[existingChangeIndex] = { ...updatedChangesArray[existingChangeIndex], newvalue: zipData, flag: updatedFlag };
                return updatedChangesArray;
            } else {
                const change = { oldvalue: oldvalue, newvalue: zipData, name: type, flag: updatedFlag };
                return [...prevChangesArray, change];
            }
        });
    }

    const getError = (data, flag) => {
        console.log("reg flag", data, flag);
        setEditErrors(data)
        setErrorFlag(flag)
    }

    function formatMobileNO(value) {
        var x = value.replace(/\D/g, '').match(/(\d{1})(\d{3})(\d{3})(\d{4})/);

        console.log("value of x", x);
        value = '+' + x[1] + '(' + x[2] + ')' + x[3] + '-' + x[4];
        console.log("mobileno", value);
        return value;
    }

    useEffect(() => {
        setState(state)
        setCity(city)
        setZipcode(zipcode)
    }, []);

    const handlePhoneAdd = () => {
        const length = phoneFields.length
        console.log("length", length);

        let object1 = {
            "oldvalue": "",
            "newvalue": "",
            "name": "Alternative Phone #",
            "id": `phoneNo${length}`,
            "flag": "Add"
        };
        let object2 = {
            "oldvalue": "",
            "newvalue": "",
            "name": "Alternative Phone # Extension",
            "id": `phoneNo${length}`,
            "flag": "Add"
        };
        changesArray.push(object1, object2);
        const values = [...phoneFields, { "phone_no": "", "extentation": "", "country_code": "+1", flag: "add" }];
        setPhoneFields(values.map((data, index) => { return { "id": `phoneNo${index}`, "phone_no": data.phone_no, "extentation": data.extentation, "country_code": data.country_code } }));
        setPhoneNo(values.map((data, index) => { return { "id": `phoneNo${index}`, "phone_no": data.phone_no, flag: data.flag, "extentation": data.extentation, "country_code": data.country_code } }));
    }

    const removePhoneFields = (index, id) => {
        let data = [...phoneNo];

        let removedPhone = data[index].phone_no == null ? "" : data[index].phone_no;
        let removedPhone1 = data[index].extentation == undefined || data[index].extentation == null ? "" : data[index].extentation;
        let removedPhone2 = data[index].country_code == undefined || data[index].country_code == null ? "" : data[index].country_code;

        data.splice(index, 1)
        setPhoneNo(data.map((data, index) => ({ ...data, "id": `phoneNo${index}`, phone_no: data.phone_no })));
        let value = [...phoneFields];
        value.splice(index, 1)
        setPhoneFields(value.map((data, index) => ({ ...data, "id": `phoneNo${index}`, phone_no: data.phone_no, })));

        const indexToRemove = changesArray.findIndex(obj => (obj.id == id) && (obj.flag == "Add"));

        if (indexToRemove !== -1) {
            let remainingArrays = changesArray.filter(obj => obj.id !== id);
            const updatedObjects = remainingArrays.map(obj => {
                const numericPart = parseInt(obj.id?.match(/\d+$/)[0]);
                if (numericPart > index) {
                    return { ...obj, id: obj.id.startsWith('phoneNo') ? `phoneNo${numericPart - 1}` : obj.id };
                }
                return obj;
            });
            setChangesArray(updatedObjects)
        }
        else {
            let remainingArrays = changesArray.filter(obj => obj.id !== id);
            const updatedObjects = remainingArrays.map(obj => {
                const numericPart = parseInt(obj.id?.match(/\d+$/)[0]);
                if (numericPart > index) {
                    return { ...obj, id: obj.id.startsWith('phoneNo') ? `phoneNo${numericPart - 1}` : obj.id };
                }
                return obj;
            });

            const newChanges = [];

            if (removedPhone.trim() !== "") {
                newChanges.push({ oldvalue: removedPhone, newvalue: "Alternative Phone # " + `${removedPhone}` + " has been removed", name: "Alternative Phone #", flag: "Remove" });
            }

            if (removedPhone1.trim() !== "") {
                newChanges.push({ oldvalue: removedPhone1, newvalue: "Alternative Phone # Extension " + `${removedPhone1}` + " has been removed", name: "Alternative Phone # Extension", flag: "Remove" });
            }

            if (removedPhone2.trim() !== "") {
                newChanges.push({ oldvalue: removedPhone2, newvalue: "Alternative Phone # Country Code " + `${removedPhone2}` + " has been removed", name: "Alternative Phone # Country Code", flag: "Remove" });
            }

            setChangesArray([...updatedObjects, ...newChanges]);


        }
    }




    updateMyProfile = (event) => {
        // setOpenLoader(true);
        event.preventDefault();

        setPrimaryPhoneError("")
        setMobilePhoneError("")
        setAddressError("")
        setStateAndCityError("")

        phoneNo.map((data, index) => {
            document.getElementById(`phoneErr${index}`).innerHTML = "";
        })
        email.map((data, index) => {
            document.getElementById(`emailErr${index}`).innerHTML = "";
        })

        // if (phoneNo[0].value === "" || phoneNo[0].value === undefined) {
        //     document.getElementById(`phoneErr${0}`).innerHTML = "Phone Number is required";
        //     return;
        // }
        // if (phoneNo.length > 0) {
        //     const phoneFilter = phoneNo.filter((data, index) => !(data.country_code == "" || data.country_code == undefined))
        //     if (phoneFilter.filter((data, index) => data.phone_no == "")?.length > 0) {
        //         phoneNo.map((data, index) => {
        //             if (data.country_code !== "" && data.phone_no == "") {
        //                 document.getElementById(`phoneErr${index}`).innerHTML = "Phone # is required";
        //                 return;
        //             }
        //         })
        //         return;
        //     }
        // }
        if (phoneNo.length > 0) {
            const phoneFilter = phoneNo.filter((data, index) => !(data.extentation == "" || data.extentation == undefined))
            if (phoneFilter.filter((data, index) => data.phone_no == "")?.length > 0) {
                phoneNo.map((data, index) => {
                    if (data.extentation !== "" && data.phone_no == "") {
                        document.getElementById(`phoneErr${index}`).innerHTML = "Phone # is required";
                        return;
                    }
                })
                return;
            }
        }

        const phoneFilter = phoneNo.filter((data, index) => data.phone_no?.length < 10)
        if (phoneFilter.filter((data, index) => data.phone_no !== "")?.length > 0) {
            phoneNo.map((data, index) => {
                // document.getElementById(`phoneErr${index}`).innerHTML = "";
                if (data.phone_no !== "" && data.phone_no.length < 10) {
                    document.getElementById(`phoneErr${index}`).innerHTML = "Phone # must have 10 digits";
                    return;
                }
            })
            return;
        }
        if (phoneNo.length > 0) {
            for (let i = 0; i < phoneNo.length; i++) {
                if (phoneNo[i].phone_no !== "") {
                    if (phoneNo[i].phone_no == phoneNumber) {
                        document.getElementById(`phoneErr${i}`).innerHTML = "Phone # should not be same";
                        return
                    }
                }
            }
        }
        if (phoneNo.length > 0) {
            for (let i = 0; i < phoneNo.length - 1; i++) {
                if (phoneNo[i].phone_no !== "") {
                    for (let n = i + 1; n < phoneNo.length; n++) {
                        // console.log(phoneNo[i].phone_no, "phoneNo")
                        // console.log(phoneNo[n].phone_no, n, "phoneNos")
                        if (phoneNo[i].phone_no === phoneNo[n].phone_no) {
                            // console.log("same phoneNo entered", phoneNo[i].id, phoneNo[n].id);
                            document.getElementById(`phoneErr${phoneNo[n].id.slice(7)}`).innerHTML = "Phone # should not be same";
                            return;
                        }
                    }
                }
                else {
                    console.log("phone is Empty")
                }
            }
        }

        // if (email[0]?.value === "" || email[0]?.value === undefined) {
        //     document.getElementById(`emailErr${0}`).innerHTML = "Email is required";
        //     return;
        // }
        if (email.filter((data, index) => data.value && !new RegExp(/^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i).test(data.value)).length > 0) {
            // console.log("email 1st if calling");
            email.map((data, index) => {
                document.getElementById(`emailErr${index}`).innerHTML = "";
                // document.getElementById(`phoneErr${index}`).innerHTML = "";
                if (data.value && !new RegExp(/^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i).test(data.value)) {
                    // console.log("email 2nd if Calling");
                    document.getElementById(`emailErr${index}`).innerHTML = "Must match the Email format";
                    return;
                }
            })
            return;
        }

        if (email.length > 0) {
            for (let i = 0; i < email.length - 1; i++) {
                if (email[i].value !== "") {
                    for (let n = i + 1; n < email.length; n++) {
                        // console.log(email[i].value, "email")
                        // console.log(email[n].value, n, "emails")
                        if (email[i].value === email[n].value) {
                            // console.log("same email entered", email[i].id, email[n].id);
                            document.getElementById(`emailErr${email[n].id.slice(5)}}`).innerHTML = "Email Id's should not be same";
                            return;
                        }
                    }
                } else {
                    console.log("email is Empty")
                }
            }
        }
        if (!address) {
            setAddressError("Address is required")
            return;
        }
        else if (address.length > 150) {
            setAddressError("Address must not exceed 150 characters")
            return;
        }
        if (!(typeof state === 'string' ? myProfileObjc.state_id : state)) {
            setStateAndCityError("1")
            return
        }
        if (!(typeof city === 'string' ? myProfileObjc.city_id : city)) {
            setStateAndCityError("2")
            return
        }
        if (!(zipcode === myProfileObjc.zipcode ? myProfileObjc.zipcode_id : zipcode)) {
            setStateAndCityError("3")
            return
        }

        const phoneNoList = phoneNo?.filter((data) => data?.phone_no !== "")
        const phoneData = phoneNoList?.filter((data) => data?.phone_no !== undefined)
        const emailList = email?.filter((data) => data?.phone_no !== "")
        const filteredChangesArray = changesArray.filter(change => !(change.oldvalue == "" && change.newvalue === ''));
        const filteredChangesflag = filteredChangesArray.length > 0 ? "yes" : "no"
        let request = {
            seller_id: sellerDetails.seller_id,
            seller_dealer_id: dealerData === "" || dealerData === "undefined" || dealerData === null ? sellerDetails.seller_dealer_id : dealerData.seller_dealer_id,
            first_name: firstName,
            last_name: lastName,
            phone_no: phoneNumber,
            email: emailId,
            emaillist: emailList.map(data => data.value),
            // phonenolist: phoneData.map(data => data.value),
            phonenolist: phoneData.map(({ id, ...rest }) => rest),
            city_id: stateCityFlag == "" ? typeof city === 'string' ? myProfileObjc.city_id : city : "",
            state_id: stateCityFlag == "" ? typeof state === 'string' ? myProfileObjc.state_id : state : "",
            zipcode_id: stateCityFlag == "" ? zipcode === myProfileObjc.zipcode ? myProfileObjc.zipcode_id : zipcode : "",

            // city_id: typeof city === 'string' ? myProfileObjc.city_id : city,
            // state_id: typeof state === 'string' ? myProfileObjc.state_id : state,
            // zipcode_id: zipcode === myProfileObjc.zipcode ? myProfileObjc.zipcode_id : zipcode,
            city_name: stateCityFlag !== "" ? city : "",
            state_name: stateCityFlag !== "" ? state : "",
            zipcode: stateCityFlag !== "" ? zipcode : "",
            address: address,
            historylist: filteredChangesArray,
            valuechanges: filteredChangesflag,
            active: 1,
            image: doc === "" ? doc : doc.length > 0 ? doc : [doc],
            seller_token: sellerDetails.seller_token,
            extentation: extentation,
            country_code: optionPhone

        };
        console.log("myProfile", request)
        // return
        if (type == "") {
            API
                .post("myProfile/update", request)
                .then((response) => {
                    if (response.data.success) {
                        const { data } = response;
                        // ls.set('userDetails', response.data.data[0]);
                        // ls.set("sellerDetails", response.data.data)
                        // ls.set('googleMapDetails', response.data.data1[0]);
                        // dispatch(LoginActions.success(response.data.data))
                        // console.log("myProfile/update response===1===", response.data.data)
                        // console.log("myProfile/update response====2===", response.data.data[0])
                        //history.push("/success");
                        togglePopup()
                        setPopupTitle("Edit My Profile");
                        setPopupMsg("Profile Successfully Edited");
                        setPopupType("success");
                        setPopupActionType("redirect");
                        setPopupActionValue("ok");
                        setPopupActionPath("/myprofile")
                        ls.set("BillofSaleId", billofsale);
                        ls.set("BillOfSaleCarId", CarId)
                        ls.set("backredirection", backUrl.slice(0, -1))
                    } else {
                        // history.push("emailerror");
                        togglePopup()
                        setPopupTitle("Edit Profile");
                        // setPopupMsg("Profile is not Edited, Please try Again");
                        setPopupMsg(response.data.error.err);
                        setPopupType("error");
                        setPopupActionType("close");
                        setPopupActionValue("close");
                    }
                }, (error) => {
                    // setOpenLoader(false);
                    // console.log(error);
                    togglePopup()
                    setPopupTitle("Error");
                    setPopupMsg("something went wrong, Please try Again");
                    setPopupType("error");
                    setPopupActionType("close");
                    setPopupActionValue("close");
                })
                .catch(function (error) {
                    if (error.response) {
                        setEditErrors(error.response.data.error)
                        setErrorFlag(true)
                    }
                });
        }
        else {
            console.log("Upload only Image Format");
        }
    }
    const getFiles = (event) => {
        const file = event.target.files[0];

        if (!file) return;

        setType("");

        if (
            file.type === "image/jpeg" ||
            file.type === "image/jpg" ||
            file.type === "image/png"
        ) {
            const reader = new FileReader();

            reader.onload = () => {
                setDoc({
                    name: file.name,
                    type: file.type,
                    size: file.size,
                    base64: reader.result, // same as FileBase64
                });
            };

            reader.readAsDataURL(file);
        } else {
            setType("0");
        }
    };


    function formatPhnNo(value) {

        let i = 0;
        for (i = 0; i < value.phone_no?.length; i++) {
            var x = 0;
            x = value.phone_no[i].replace(/\D/g, "").match(/(\d{3})(\d{3})(\d{4})/);
            value.phone_no[i] = "(" + x[1] + ")" + x[2] + "-" + x[3];
        }

        return setPhoneFields(value?.map((data, index) => { return { ...data, "id": `phoneNo${index}`, "phone_no": data.phone_no } }))
    }

    useEffect(() => {
        let request = {
            seller_id: sellerDetails.seller_id,
            seller_token: sellerDetails.seller_token,
        };

        const state = API.post('seller_profile/condition', request);
        state.then(res => {
            console.log("res", res.data.data)
            if (res.data.success === true) {
                setFirstName(res.data.data[0]?.first_name);
                setLastName(res.data.data[0]?.last_name);
                // setPrimaryPhone(res.data.data[0].phone_no);
                // setMobilePhone(res.data.data[0].mobile_no);           
                setEmailId(res.data.data[0]?.email);
                console.log("setEmailId", res.data.data[0]?.email)
                setPhoneNumber(res.data.data[0]?.phone_no)
                setAddress(res.data.data[0]?.address);
                setCity(res.data.data[0]?.city_name);
                setState(res.data.data[0]?.state_name);
                setZipcode(res.data.data[0]?.zipcode);
                // setLocationName(res.data.data[0].address);
                setMyProfileObj(res.data.data[0]);
                reset(res.data.data[0]);
                setImage(res.data.data[0]?.image)
                setExtentation(res.data.data[0]?.extentation)
                setOptionPhone(res.data.data[0].country_code);

                // formatPhone(res.data.data[0]?.phone_no)
                // if(res.data.data[0].mobile_no != ""){
                // formatMobile(res.data.data[0].mobile_no);
                // }
                res.data.data[0]?.emaillist.length > 0 ?
                    setFields(res.data.data[0]?.emaillist.map((data, index) => { return { "id": `email${index}`, "value": data.email } }))
                    :
                    setFields([{ "id": `email${0}`, "value": "" }]);
                setEmail(res.data.data[0]?.emaillist.map((data, index) => { return { "id": `email${index}`, "value": data.email } }))
                res.data.data[0]?.phonenolist.length > 0 ?
                    formatPhnNo(res.data.data[0]?.phonenolist.map(data => data)) :
                    setPhoneFields([{ "id": `phoneNo${0}`, "phone_no": "", "extentation": "", "country_code": "+1" }])

                res.data.data[0]?.phonenolist.length > 0 ?
                    setPhoneNo(res.data.data[0]?.phonenolist.map((data, index) => { return { ...data, "id": `phoneNo${index}`, "phone_no": data.phone_no, "country_code": data.country_code } }))
                    // setPhoneNo(res.data.data[0]?.phonenolist.map((data, index) => { return { "id": `phoneNo${index}`, "value": data.phone_no } }))
                    :
                    setPhoneNo([{ "id": `phoneNo${0}`, "phone_no": "", "extentation": "", "country_code": "+1" }])
                setLoading(false);
            }
            else {
                setEditErrors(res.data.error)
                setErrorFlag(true)
            }

        })
            .catch(function (error) {
                if (error.response) {
                    setEditErrors(error.response.data.error)
                    setErrorFlag(true)
                }
            });
    }, [reset]);


    function formatPhone(value) {
        var x = value.replace(/\D/g, '').match(/(\d{3})(\d{3})(\d{4})/);
        console.log("formatPhoneNumber x", x);
        value = '+1' + '(' + x[1] + ')' + x[2] + '-' + x[3];
        console.log("formatPhoneNumber", value);
        return setPrimaryPhone(value);
    }
    function formatMobile(value) {
        var x = value.replace(/\D/g, '').match(/(\d{3})(\d{3})(\d{4})/);
        console.log("formatPhoneNumber x", x);
        value = '+1' + '(' + x[1] + ')' + x[2] + '-' + x[3];
        console.log("formatPhoneNumber", value);
        return setMobilePhone(value);
    }
    const handleOnChangePhone = (value) => {
        setPrimaryPhone(value);
        setCellFlag(true)
        console.log("inside handle")

        console.log("phn no", value)
    }

    const handleOnChangeMobile = (value) => {
        setMobilePhone(value);
        setAlterPhoneFlag(true)
        console.log("inside handle")

        console.log("phn no", value)
    }

    const handleAdd = () => {
        const length = fields.length
        console.log("length", length);
        let object1 = {
            "oldvalue": "",
            "newvalue": "",
            "name": "Alternative Email",
            "id": `email${length}`,
            "flag": "Add"
        };

        changesArray.push(object1);
        const values = [...fields, { "value": "" }];
        setFields(values.map((data, index) => { return { "id": `email${index}`, value: data.value } }));
        setEmail(values.map((data, index) => { return { "id": `email${index}`, value: data.value } }));
    }


    const removeFields = (index, id) => {
        setChangesFlag("yes")

        let data = [...email];
        let removedEmail = data[index].value == null ? "" : data[index].value;

        data.splice(index, 1);
        setEmail(data.map((data, index) => ({ ...data, "id": `email${index}`, value: data.value })));

        let value = [...fields];
        value.splice(index, 1);
        setFields(value.map((data, index) => ({ ...data, "id": `email${index}`, value: data.value })));
        const indexToRemove = changesArray.findIndex(obj => (obj.id == id) && (obj.flag == "Add"));

        if (indexToRemove !== -1) {
            let remainingArrays = changesArray.filter(obj => obj.id !== id);
            const updatedObjects = remainingArrays.map(obj => {
                const numericPart = parseInt(obj.id?.match(/\d+$/)[0]);
                if (numericPart > index) {
                    return { ...obj, id: obj.id.startsWith('email') ? `email${numericPart - 1}` : obj.id };
                }
                return obj;
            });
            setChangesArray(updatedObjects)
        }
        else {
            if (removedEmail.trim() !== "") {
                let remainingArrays = changesArray.filter(obj => obj.id !== id);
                const updatedObjects = remainingArrays.map(obj => {
                    const numericPart = parseInt(obj.id?.match(/\d+$/)[0]);
                    if (numericPart > index) {
                        return { ...obj, id: obj.id.startsWith('email') ? `email${numericPart - 1}` : obj.id };
                    }
                    return obj;
                });
                setChangesArray(updatedObjects)
                setChangesArray((prevChangesArray) => [
                    ...prevChangesArray,
                    { oldvalue: removedEmail, newvalue: "Alternative Email " + `${removedEmail}` + " has been removed", name: "Alternative Email", flag: "Remove" },
                ]);
            }

        }
    };

    const handleBackButton = () => {

        history.push({
            pathname: back,
            state: { BillofSale: billofsale, CarId: CarId },
        });
        ls.set("backredirection", backUrl.slice(0, -1))

    }
    const [originalValues, setOriginalValues] = useState({})
    const [originalEmailValues, setOriginalEmailValues] = useState({})

    const onhandlePhone = (data, phnId, index) => {
        const id = phnId;
        const phone_no = data;

        const updatedOriginalValues = { ...originalValues };

        if (!phoneNo?.length) {
            setPhoneNo([{ ...phoneNo, id, phone_no }]);
            setPhoneFields([{ id, phone_no }]);
            updatedOriginalValues[id] = phone_no;
            setOriginalValues({ [id]: "" });

        } else {
            const findIndex = phoneNo.findIndex((myData) => myData.id === id);

            if (findIndex >= 0) {
                let phoneNoData = phoneNo;

                if (!updatedOriginalValues.hasOwnProperty(id)) {
                    updatedOriginalValues[id] = phoneNoData[findIndex].phone_no;
                }

                phoneNoData[findIndex].phone_no = phone_no;
                setPhoneNo(phoneNoData);
                setPhoneFields(phoneNoData);

                setChangesFlag("yes");

                setOriginalValues(updatedOriginalValues);

                const existingChangeIndex = changesArray.findIndex(
                    (change) => change.name === "Alternative Phone #" && change.id === id
                );

                if (existingChangeIndex !== -1) {
                    const updatedChangesArray = [...changesArray];
                    updatedChangesArray[existingChangeIndex] = {
                        oldvalue: updatedOriginalValues[id],
                        newvalue: phone_no,
                        name: "Alternative Phone #",
                        id,
                        flag: !updatedOriginalValues[id] ? "Add" : "Edit"

                    };
                    setChangesArray(updatedChangesArray);
                } else {
                    const change = {
                        oldvalue: updatedOriginalValues[id],
                        newvalue: phone_no,
                        name: "Alternative Phone #",
                        id,
                        flag: !updatedOriginalValues[id] ? "Add" : "Edit"

                    };
                    setChangesArray([...changesArray, change]);
                }
            } else {
                setPhoneNo([...phoneNo, { id, phone_no }]);
                setPhoneFields([...phoneNo, { id, phone_no }]);

                setChangesFlag("yes");
                const change = {
                    oldvalue: "",
                    newvalue: phone_no,
                    name: "Alternative Phone #",
                    id,
                };
                setChangesArray([...changesArray, change]);
            }
        }
    };
    const onhandleEmail = (e, emailId, index) => {
        const id = emailId;
        const value = e.target.value;
        const updatedOriginalValues = { ...originalEmailValues };

        if (!email.length) {
            setEmail([{ ...email, id, value }]);
            setFields([{ id, value }]);
            updatedOriginalValues[id] = value;
            setOriginalEmailValues({ [id]: "" });


        } else {
            const findIndex = email.findIndex((myData) => myData.id === id);

            if (findIndex >= 0) {
                let emailData = [...email];

                if (!updatedOriginalValues.hasOwnProperty(id)) {
                    updatedOriginalValues[id] = emailData[findIndex].value;
                }

                emailData[findIndex].value = value;
                // setOtherEmail(value);
                setEmail(emailData);
                setFields(emailData);
                setChangesFlag("yes");
                setOriginalEmailValues(updatedOriginalValues);

                const existingChangeIndex = changesArray.findIndex(
                    (change) => change.name === "Alternative Email" && change.id === id
                );

                if (existingChangeIndex !== -1) {
                    const updatedChangesArray = [...changesArray];
                    updatedChangesArray[existingChangeIndex] = {
                        oldvalue: updatedOriginalValues[id],
                        newvalue: value,
                        name: "Alternative Email",
                        id,
                        flag: !updatedOriginalValues[id] ? "Add" : "Edit",
                    };
                    setChangesArray(updatedChangesArray);
                } else {
                    const change = {
                        oldvalue: updatedOriginalValues[id],
                        newvalue: value,
                        name: "Alternative Email",
                        id,
                        flag: !updatedOriginalValues[id] ? "Add" : "Edit",
                    };
                    setChangesArray([...changesArray, change]);
                }
            } else {
                setEmail([...email, { id, value }]);
                setFields([...email, { id, value }]);

                setChangesFlag("yes");
                const change = {
                    oldvalue: "",
                    newvalue: value,
                    name: "Alternative Email",
                    id,
                };
                setChangesArray([...changesArray, change]);
            }
        }
    };
    const handleLables = (value, label) => {
        setChangesFlag("yes")
        if (label === "Primary Phone # Extension") {
            console.log("check the changing value");
            const oldvalue = myProfileObjc?.extentation;
            const data = value.replace(/\D/g, "");
            setExtentation(data)

            const existingChangeIndex = changesArray.findIndex((change) => change.name === label);
            if (existingChangeIndex !== -1) {
                const updatedChangesArray = [...changesArray];
                updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: data, name: label };
                setChangesArray(updatedChangesArray);
            } else {
                const change = { oldvalue: oldvalue, newvalue: data, name: "Primary Phone # Extension" };
                setChangesArray([...changesArray, change]);
            }

        }
        if (label === "Primary Phone # Country Code") {
            console.log("check the changing value");
            const oldvalue = myProfileObjc?.country_code;
            // const data = value.replace(/\D/g, "");
            setOptionPhone(value)

            const existingChangeIndex = changesArray.findIndex((change) => change.name === label);
            if (existingChangeIndex !== -1) {
                const updatedChangesArray = [...changesArray];
                updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: value, name: label };
                setChangesArray(updatedChangesArray);
            } else {
                const change = { oldvalue: oldvalue, newvalue: value, name: "Primary Phone # Country Code" };
                setChangesArray([...changesArray, change]);
            }

        }
    }
    const onhandleExtentation = (data, phnId, index) => {
        const id = phnId;
        const data1 = data.replace(/\D/g, "");

        const extentation = data1;

        const updatedOriginalValues = { ...originalValues1 };
        if (!phoneNo?.length) {
            setPhoneNo([{ ...phoneNo, id, extentation }]);
            setPhoneFields([{ id, extentation }]);

            updatedOriginalValues[id] = extentation;
            setOriginalValues1({ [id]: "" });

        } else {
            const findIndex = phoneNo.findIndex((myData) => myData.id === id);
            console.log("findIndex", findIndex);
            if (findIndex >= 0) {
                let phoneNoData = phoneNo;
                if (!updatedOriginalValues.hasOwnProperty(id)) {
                    updatedOriginalValues[id] = phoneNoData[findIndex].extentation;
                }

                phoneNoData[findIndex].extentation = extentation;
                setPhoneNo(phoneNoData);
                setPhoneFields(phoneNoData);
                setChangesFlag("yes");
                setOriginalValues1(updatedOriginalValues);
                const existingChangeIndex = changesArray.findIndex(
                    (change) => change.name === "Alternative Phone # Extension" && change.id === id
                );

                if (existingChangeIndex !== -1) {
                    const updatedChangesArray = [...changesArray];
                    updatedChangesArray[existingChangeIndex] = {
                        oldvalue: updatedOriginalValues[id],
                        newvalue: extentation,
                        name: "Alternative Phone # Extension",
                        id,
                        flag: !updatedOriginalValues[id] ? "Add" : "Edit"

                    };
                    setChangesArray(updatedChangesArray);
                } else {
                    const change = {
                        oldvalue: updatedOriginalValues[id],
                        newvalue: extentation,
                        name: "Alternative Phone # Extension",
                        id,
                        flag: !updatedOriginalValues[id] ? "Add" : "Edit"

                    };
                    setChangesArray([...changesArray, change]);
                }
            } else {
                setPhoneNo([...phoneNo, { id, extentation }]);
                setPhoneFields([...phoneNo, { id, extentation }]);

                setChangesFlag("yes");
                const change = {
                    oldvalue: "",
                    newvalue: extentation,
                    name: "Alternative Phone # Extension",
                    id,
                };
                setChangesArray([...changesArray, change]);
            }
        }
    };
    const onhandleCode = (data, phnId, index) => {
        const id = phnId;
        // const data1 = data.replace(/\D/g, "");
        const country_code = data;
        const updatedOriginalValues = { ...originalValues2 };
        if (!phoneNo?.length) {
            setPhoneNo([{ ...phoneNo, id, country_code }]);
            setPhoneFields([{ id, country_code }]);

            updatedOriginalValues[id] = country_code;
            setOriginalValues2({ [id]: "" });

        } else {
            const findIndex = phoneNo.findIndex((myData) => myData.id === id);
            if (findIndex >= 0) {
                let phoneNoData = phoneNo;
                if (!updatedOriginalValues.hasOwnProperty(id)) {
                    updatedOriginalValues[id] = phoneNoData[findIndex].country_code;
                }

                phoneNoData[findIndex].country_code = country_code;
                setPhoneNo(phoneNoData);
                setPhoneFields(phoneNoData);
                setChangesFlag("yes");
                setOriginalValues2(updatedOriginalValues);
                const existingChangeIndex = changesArray.findIndex(
                    (change) => change.name === "Alternative Phone # Country Code" && change.id === id
                );

                if (existingChangeIndex !== -1) {
                    const updatedChangesArray = [...changesArray];
                    updatedChangesArray[existingChangeIndex] = {
                        oldvalue: updatedOriginalValues[id],
                        newvalue: country_code,
                        name: "Alternative Phone # Country Code",
                        id,
                        flag: !updatedOriginalValues[id] ? "Add" : "Edit"

                    };
                    setChangesArray(updatedChangesArray);
                } else {
                    const change = {
                        oldvalue: updatedOriginalValues[id],
                        newvalue: country_code,
                        name: "Alternative Phone # Country Code",
                        id,
                        flag: !updatedOriginalValues[id] ? "Add" : "Edit"

                    };
                    setChangesArray([...changesArray, change]);
                }
            } else {
                setPhoneNo([...phoneNo, { id, country_code }]);
                setPhoneFields([...phoneNo, { id, country_code }]);

                setChangesFlag("yes");
                const change = {
                    oldvalue: "",
                    newvalue: country_code,
                    name: "Alternative Phone # Country Code",
                    id,
                };
                setChangesArray([...changesArray, change]);
            }
        }
    };
    useEffect(() => fetchCountry()
        , [])

    async function fetchCountry() {
        const country = API.get('country');
        country.then((response) => {

            if (response.data.success === true) {
                setCountry(response.data.data);
            }
            else {
                setEditErrors(response.data.error.name)
                setErrorFlag(true)
            }

        }).catch(function (error) {
            if (error.response) {
                setEditErrors(error.response.data.error)
                setErrorFlag(true)
            }
        });
    }
    return (
        <div>


            <main id="main" className="inner-page">
                {errorFlag === true ? <PageNotFound error={editErrors} /> :
                    <>
                        {loading ? <Loading /> :
                            <div id="addaddress" className="addaddress_block">
                                <div className="container-fluid inner-page-space" >
                                    <div class="common-heading">
                                        <div className="row">
                                            <div className="col-lg-4">
                                            </div>
                                            <div className="col-lg-4">
                                                <div class="title">
                                                    <p class="inner-title">Edit My Profile</p>
                                                </div>
                                            </div>
                                            <div className="col-lg-4">
                                            </div>
                                        </div>
                                    </div>
                                    <div className="addaddressblock">
                                        <div className="row content">
                                            <div className="col-lg-4 col-md-12 col-sm-12 mgaccountleftblock">
                                                <ManageAccountLinks />
                                            </div>
                                            <div className="col-lg-8 col-md-12 col-sm-12 myprofileeditform">
                                                <div className="col-lg-12 adduserpage-inner">
                                                    <form className="registrationform">
                                                        <div class="common-heading">
                                                            <div className="row">
                                                                <div className="col-lg-4">
                                                                    <button className="back-btn-paymentform backBtn" onClick={() => handleBackButton()}><i className="icofont-arrow-left"></i> Back</button>
                                                                </div>
                                                                <div className="col-lg-4">
                                                                    <div class="title">
                                                                        <p class="inner-title">Edit My Profile</p>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4">
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-lg-12 form-group my-profile-img">
                                                                <div className="col-lg-12 form-group my-profile-img">
                                                                    <div className="user-upload-btn-wrapper">
                                                                        {doc === "" ? (
                                                                            <img alt="" src={sellerDetails?.image || adduser} />
                                                                        ) : (
                                                                            <img alt="" src={doc.base64} />
                                                                        )}

                                                                        <span className="proCamera"></span>

                                                                        {type === "0" && (
                                                                            <div className="form-input-error">
                                                                                Upload only Image Format
                                                                            </div>
                                                                        )}

                                                                        <input
                                                                            type="file"
                                                                            accept="image/png,image/jpeg,image/jpg"
                                                                            hidden
                                                                            id="profileImage"
                                                                            onChange={getFiles}
                                                                        />

                                                                        <label htmlFor="profileImage" className="upload-label">
                                                                            Change Image
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-12 form-group">
                                                                <div className="tbox">
                                                                    <input type="text" defaultValue={myProfileObjc?.first_name} className="form-control textbox" placeholder="" required disabled onChange={(e) => setFirstName(e.target.value)} />
                                                                    <label htmlFor="first_name" className={firstName != "" ? "input-has-value" : ""}>First Name</label>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-12 form-group">
                                                                <div className="tbox">
                                                                    <input type="text" defaultValue={myProfileObjc?.last_name} className="form-control textbox" placeholder="" required disabled onChange={(e) => setLastName(e.target.value)} />
                                                                    <label htmlFor="last_name" className={lastName != "" ? "input-has-value" : ""}>Last Name</label>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-4 form-group countrycode">
                                                                <div className="tbox">
                                                                    <select className="form-control custom-select browser-default textbox" id="drop" placeholder=""
                                                                        onChange={(e) => { handleLables(e.target.value, "Primary Phone # Country Code") }} value={optionPhone}
                                                                    >
                                                                        <option style={{ display: "none" }}>{optionPhone}</option>
                                                                        {country.length > 0 &&
                                                                            <>
                                                                                {country.map((country) => <>
                                                                                    <option key={country.id} value={`+${country.country_code}`} >
                                                                                        {country?.country_name}({`+${country.country_code}`})
                                                                                    </option>
                                                                                </>)}
                                                                            </>}
                                                                    </select>
                                                                    <label for="drop" className={"input-has-value"}>Country Code</label>

                                                                </div>
                                                            </div>
                                                            <div className="col-lg-5 form-group ">
                                                                <div className="tbox ">
                                                                    <PhoneInputs
                                                                        className="textbox"
                                                                        country={'us'}
                                                                        disableDropdown={true}
                                                                        disableCountryCode={true}
                                                                        onlyCountries={['us']}
                                                                        value={phoneNumber}
                                                                        disabled
                                                                        placeholder=""
                                                                    ></PhoneInputs>
                                                                    <label htmlFor="phoneNo" className={"input-has-value"}> Primary Phone #</label>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-3 form-group">
                                                                <div className="tbox extn-codepr">
                                                                    <input
                                                                        type="text"
                                                                        class="form-control"
                                                                        id="extentation1"
                                                                        value={extentation}
                                                                        onChange={(e) => { handleLables(e.target.value, "Primary Phone # Extension"); }}

                                                                    />
                                                                    <label for="drop" className={"input-has-value"}>Extension</label>

                                                                </div>
                                                            </div>
                                                            <div className="col-lg-4 form-group countrycode">
                                                                {phoneNo.length > 0 ? phoneNo.map((data, index) =>
                                                                    <div className="tbox">
                                                                        <select className="form-control custom-select browser-default textbox" id="drop" placeholder=""
                                                                            onChange={(e) => onhandleCode(e.target.value, `phoneNo${index}`, index)} value={data.country_code}>
                                                                            <option style={{ display: "none" }}>{data.country_code}</option>
                                                                            {country.length > 0 &&
                                                                                <>
                                                                                    {country.map((country) => <>
                                                                                        <option key={country.id} value={`+${country.country_code}`} >
                                                                                            {country?.country_name}({`+${country.country_code}`})
                                                                                        </option>
                                                                                    </>)}
                                                                                </>}
                                                                        </select>
                                                                        <label for="drop" className={"input-has-value"}>Country Code</label>

                                                                    </div>
                                                                ) : ""}
                                                            </div>
                                                            <div className="col-lg-5 form-group ">
                                                                {phoneNo.map((item, index) =>
                                                                    <div className="tbox ">
                                                                        <PhoneInputs
                                                                            className="textbox"
                                                                            country={'us'}
                                                                            disableDropdown={true}
                                                                            disableCountryCode={true}
                                                                            onlyCountries={['us']}
                                                                            value={item.phone_no}
                                                                            onChange={(data) => onhandlePhone(data, `phoneNo${index}`, index)}
                                                                            placeholder=""
                                                                        ></PhoneInputs>
                                                                        <label htmlFor={`phoneNo${index}`} className={"input-has-value"}>Alternative Phone #</label>
                                                                        <p className="form-input-error" id={`phoneErr${index}`} ></p>
                                                                    </div>
                                                                    // ) : ""}
                                                                )}

                                                            </div>
                                                            <div className="col-lg-3 form-group">
                                                                {phoneNo.map((data, index) =>
                                                                    <div className="tbox extn-codepr">
                                                                        <input
                                                                            type="text"
                                                                            class="form-control"
                                                                            id="extentation1"
                                                                            value={data.extentation}
                                                                            onChange={(e) => onhandleExtentation(e.target.value, `phoneNo${index}`, index)}
                                                                        />
                                                                        <label for="drop" className={"input-has-value"}>Extension</label>


                                                                        {index === 0 ?
                                                                            <button class="btn btn-outline-secondary rounded-1" type="button" id="button-addon2" onClick={handlePhoneAdd}>+ </button>
                                                                            :
                                                                            <button class="btn btn-outline-secondary " type="button" id="button-lesson2" onClick={() => removePhoneFields(index, `phoneNo${index}`)}>- </button>
                                                                        }
                                                                    </div>
                                                                )}
                                                            </div>

                                                            <div className=" col-lg-12 form-group">
                                                                <div className="tbox">
                                                                    <input className="form-control textbox" type="text" placeholder="" id="email" name="email" disabled
                                                                        defaultValue={emailId} />
                                                                    <label htmlFor="email" className={"input-has-value"}>Primary Email</label>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-12 form-group">
                                                                {fields.map((data, index) =>
                                                                    <>
                                                                        <div className="tbox ">
                                                                            <input className="form-control textbox" type="text" placeholder="" id={`email${index}`}
                                                                                value={data.value} onChange={(e) => onhandleEmail(e, `email${index}`, index)} />
                                                                            <label htmlFor="email" className={data.email != "" ? "input-has-value" : ""}>Alternate Email</label>
                                                                            {index === 0 ?
                                                                                <button class="btn btn-outline-secondary-2 " type="button" id="button-addon2 phnadd" onClick={handleAdd}> + </button>
                                                                                :
                                                                                <button class="btn btn-outline-secondary-2 " type="button" id="button-lesson2 phnadd" onClick={() => removeFields(index, `email${index}`)}> - </button>
                                                                            }
                                                                        </div>
                                                                        <p className="form-input-error1" id={`emailErr${index}`} ></p>
                                                                    </>
                                                                )}

                                                            </div>
                                                            <div className="col-lg-12 form-group">
                                                                <div className="tbox">
                                                                    <input type="text" defaultValue={myProfileObjc?.address} className="form-control textbox" placeholder="" onChange={handleAddressChange} /* onChange={(e) => setAddress(e.target.value)} */ />
                                                                    <label htmlFor="address" className={address != "" ? "input-has-value" : ""}>Address</label>
                                                                    <p className="form-input-error" >{addressError}</p>

                                                                </div>
                                                            </div>
                                                            <StateAndCitySearch
                                                                // setStateValue={getStateName}
                                                                // setCityValue={getCityName}
                                                                // setZipcodeValue={getZipCodeId}
                                                                setStateValue={(stateData, flag) => getStateName(stateData, flag, 'state')}
                                                                setCityValue={(cityData, flag) => getCityName(cityData, flag, 'city')}
                                                                setZipcodeValue={(zipData, flag) => getZipCodeId(zipData, flag, 'zipcode')}
                                                                setNewError={getError}
                                                                isEdit={true}
                                                                defaultStateValue={state}
                                                                defaultCityValue={city}
                                                                defaultZipcodeValue={zipcode}
                                                                stateCityValidation={stateAndCityError}

                                                            />

                                                            {/* <div className="col-sm-12 form-group ">

                                                    <p className="form-input-cityerror padd-marking"> {stateAndCityError} </p>
                                                </div> */}
                                                            {/* <div className="col-sm-12 form-group">
                            <div className="tbox">
                                <input type="text" defaultValue={city} className="form-control textbox" placeholder="" required onChange={(e) => setCity(e.target.value)} />
                                <label htmlFor="city_id" className={city !="" ? "input-has-value" : ""}>City</label>
                            </div>
                            </div>
                            <div className="col-sm-12 form-group">
                            <div className="tbox">
                                <input type="text" defaultValue={state} className="form-control textbox" placeholder="" required onChange={(e) => setState(e.target.value)} />
                                <label htmlFor="state_id" className={state !="" ? "input-has-value" : ""}>State</label>
                            </div>
                            </div>
                            <div className="col-sm-12 form-group">
                            <div className="tbox">
                                <input type="text" defaultValue={zipcode} className="form-control textbox" placeholder="" required onChange={(e) => setZipcode(e.target.value)} />
                                <label htmlFor="zipcode_id" className={zipcode !="" ? "input-has-value" : ""}>Zipcode</label>
                            </div>
                            </div> */}

                                                            {/* <div className="col-sm-12 form-group">
                            <div className="tbox">
                                <input type="text" defaultValue={myProfileObjc.address} className="form-control textbox" placeholder="" required onChange={(e) => setLocationName(e.target.value)} />
                                <label htmlFor="address" className={locationName !="" ? "input-has-value" : ""}>Location Name</label>
                            </div>
                            </div> */}


                                                            <div className="col-lg-12 loginBtn">
                                                                <button className="cta-btn" onClick={updateMyProfile} >Update</button>
                                                            </div>
                                                        </div>
                                                    </form>

                                                </div></div></div></div></div></div>}</>}

                {confirmationFlag &&
                    <>
                        <Modal show={true} onHide={confirmationPopup} centered>
                            <Modal.Header className="Terms-login">
                                <h2>Edit confirmation</h2>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="CommonModalbody">

                                    <p>Are you sure,If you want to Edit My Profile Information please confirm</p>
                                </div>

                                <div className="col-md-12 btns confirmation ">
                                    <button className="cta-btns" onClick={confirmationPopup} >CANCEL</button>
                                    <button className="cta-btns" onClick={updateMyProfile} >OK</button>
                                </div>

                            </Modal.Body>
                        </Modal>
                    </>}
                <section id="playstoreBlock" className="playstoreBlock">
                    <div className="container">
                        <div className="row content">
                            <div className="col-lg-12">
                                <img src={appstore} />
                                <img src={googleplay} />
                            </div>
                        </div>
                    </div>
                </section>
                {
                    isOpen &&
                    <CommonPopup
                        handleClose={togglePopup}
                        popupTitle={popupTitle}
                        popupMsg={popupMsg}
                        popupType={popupType}
                        popupActionType={popupActionType}
                        popupActionValue={popupActionValue}
                        popupActionPath={popupActionPath}
                    />
                }
            </main >

        </div >


    )
}

export default EditMyProfile;